import { Icon } from '@latitude/icons';
import { Text } from '@latitude/text';
import { cn } from '@latitude/token-utils';
import type { HTMLAttributes } from 'react';

import { messageVariants } from '../../variants/message-variants';

/**
 * Represents a form message component.
 *
 * @component
 * @example
 * ```tsx
 * <FormMessage className="my-form-message" error={true}>
 *   This field is required.
 * </FormMessage>
 * ```
 */
export type FieldErrorProps = HTMLAttributes<HTMLDivElement> & {
  errorMessage?: string;
};

// comp-text-field-web-sub-text-font-family
export const FieldError = ({
  className,
  id,
  errorMessage,
  ...props
}: FieldErrorProps) => (
  <div
    id={id}
    className={cn(messageVariants({ error: !!errorMessage }), className)}
    {...props}
  >
    <Text
      className={cn([
        'flex',
        'items-center',
        'gap-spacing-comp-form-medium-gap',
        'font-comp-form-sub-text-font-family',
        'font-comp-form-sub-text-font-weight',
        'leading-font-comp-form-sub-text-line-height',
        'ml-sizing-sys-size-2',
      ])}
      variant="captionMedium"
    >
      <Icon
        name="alert-circle"
        width="16"
        height="16"
        className="w-sizing-sys-size-16 h-sizing-sys-size-16"
        style={{
          position: 'relative',
          top: '-1px',
        }}
      />
      {errorMessage}
    </Text>
  </div>
);
